module.exports = __webpack_public_path__ + "img/Bildmarke.289af181.png";